import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso2.vue?vue&type=template&id=401bcc0f&lang=html"
import script from "./ParametrizacaoAcaoPasso2.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoPasso2.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoAcaoPasso2.vue?vue&type=style&index=0&id=401bcc0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports